import { AspectRatio } from "@cloudinary/url-gen/qualifiers";
import Skeleton from "react-loading-skeleton";

const ItemDisplaySkeleton = () => {

    return (
        <div className='item-display-content'>
            <div className='carousel-div' style={{aspectRatio: "1 / 1", display: "block", lineHeight: 1}}>
                <Skeleton containerClassName="flex=1" width="100%" height="100%" />
            </div>

            <div className='item-display-info' >
                <Skeleton width="50%" height="100%" />
                <Skeleton width="10%" height="100%" />
                <Skeleton width="70%" height="100%" />
                <hr id='solid'/>
                <div style={{display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", lineHeight: 1}}>
                    <Skeleton circle width="20px" height="20px"/>
                    <Skeleton width="150px" height="15px"/>
                </div>
            </div>
        </div>
    )
}

export default ItemDisplaySkeleton